import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/shared/components/shadcn'

import TooltipIcon from '@/shared/assets/icons/tooltip.svg?react'
import { useRef, useState } from 'react'

type TooltipProps = {
  text: string
}

export const BaseTooltip = ({ text }: TooltipProps) => {
  const [open, setOpen] = useState(false)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  const handleOpen = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current)
    setOpen(true)
  }

  const handleDelayedClose = () => {
    timeoutRef.current = setTimeout(() => {
      setOpen(false)
    }, 800)
  }
  return (
    <TooltipProvider>
      <Tooltip open={open} onOpenChange={setOpen}>
        <TooltipTrigger
          className="flex items-center justify-center"
          onClick={(e) => {
            e.preventDefault()
            handleOpen()
          }}
          onMouseEnter={handleOpen}
          onMouseLeave={handleDelayedClose}
          onTouchStart={handleOpen}
          onTouchEnd={handleDelayedClose}
        >
          <div className="text-text-secondary hover:text-primary">
            <TooltipIcon />
          </div>
        </TooltipTrigger>
        <TooltipContent className="max-w-[300px] md:max-w-full break-words p-2">
          <p className="break-normal">{text}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
